// @flow
/* eslint-disable */
/** @jsx jsx */

import { jsx } from '@emotion/core'
import * as React from 'react'
import { FlexGrid } from 'wijmo/wijmo.react.grid'
import { FlexGridFilter } from 'wijmo/wijmo.react.grid.filter'
import { GroupPanel } from 'wijmo/wijmo.react.grid.grouppanel'
import { GroupRow } from 'wijmo/wijmo.grid'
import * as wjcCore from 'wijmo/wijmo'
import cuid from 'cuid'
import deepEqual from 'deep-equal'
import type { ColumnsMap, FormatterArgs, GridItem } from '../types'
import { FreezeBar } from '../controls/FreezeBar'
import Loading from './Loading'
import Container from './Container'
import DragDropOverlay from './DragDropOverlay';

type Props = {
  active?: boolean,
  collection: any, // TODO: check proper type
  columnsMapping?: ColumnsMap,
  onRowSelected: (any) => mixed,
  onGridUpdated: () => mixed,
  onGridWillUnmount: () => mixed,
  onColSorted: () => mixed,
  onColResized: () => mixed,
  onColDragged: () => mixed,
  onColFreezed: () => mixed,
  onRowFreezed: () => mixed,
  onCellEditEnded?: ({
    col: any,
    row: any,
    newValue: any,
    oldValue: any,
  }) => mixed,
  onClearSelection: () => mixed,
  onCurrentItemChanged: (any) => mixed,
  onGroupPanelChanged: () => mixed,
  frozenColumns?: number,
  refetching: boolean,
  hasAllColumnsHidden: boolean,
  hasDataToDisplay: boolean,
  formatters?: (formattersArgs: FormatterArgs) => Array<any>,
  showFrozenBars?: boolean,
  showGroupPanel?: boolean,
  isFullPage?: boolean,
  addGrandTotalRow?: boolean,
  formattersArgs?: FormatterArgs,
  paginated?: boolean,
  grandTotalRowCustomContent?: (item: GridItem) => number,
  gridHeight: Number,
  setAggregateTotal: () => {},
  aggregateTotal: Number, //TODO: In case we need to add aggregateTotal
  itemId: String, //TODO: In case we need to add aggregateTotal
  menuRef: any,
  isMobile: Boolean,
  handlerAdded: Boolean,
}

type State = {
  selectedItems: number,
  currentItem: any,
}

export const FILTER_VALUES_LIMIT = 7000;

class App extends React.Component<Props, State> {
  collection: any // TODO: check proper type
  grid: FlexGrid
  freezeBarCol: FreezeBar
  id: string
  panelGroupInitialized: boolean
  panel: GroupPanel
  grandTotalRowAdded: boolean
  grandTotalRowHandler: () => mixed
  loadedRowsHandler: () => mixed
  formatters: Array<any> // TODO: remove any
  gridFilter: FlexGridFilter;

  static defaultProps = {
    columnsMapping: [],
    collection: {},
    isFullPage: true,
    showFrozenBars: false,
    showGroupPanel: false,
    multiColumnSort: false
  }

  constructor(props: Props) {
    super(props)

    this.state = {
      currentItem: null,
      selectedItems: 0,
      disabledInertialScrolling: false,
      handlerAdded: false,
    }

    this.id = cuid()

    if (props.collection) {
      // Handler for changing the selected item
      if (props.collection.currentChanged) {
        props.collection.currentChanged.addHandler(() => {
          this.setState({ currentItem: props.collection.currentItem }, () => {
            if (
              !props.collection.currentItem ||
              Object.keys(props.collection.currentItem).length === 0
            ) {
              return
            }

            this.props.onCurrentItemChanged(this.state.currentItem)
          })
        })

        props.collection.pageChanged.addHandler(() => {
          this.removeSelection()

          this.props.onClearSelection()
        })

        this.gridRef = React.createRef()
        this.gridContainerRef = React.createRef();
      }
    }
  }

  removeSelection = () => {
    if (!this.grid || typeof this.grid.select !== 'function') return

    this.grid.select(-1, -1)
  }

  connectGroupPanelWithGrid = (grid: FlexGrid) => {
    const panel = wjcCore.Control.getControl(
      document.getElementById(`panel-${this.id}`),
    )

    if (panel) {
      panel.grid = grid

      panel.addEventListener(panel.hostElement, 'drop', () => {
        this.props.onGroupPanelChanged()
      })

      panel.addEventListener(panel.hostElement, 'click', () => {
        this.props.onGroupPanelChanged()
      })

      this.panel = panel
      this.panelGroupInitialized = true
    }
  }

  componentWillUnmount() {
    // Suppress all internal grid refresh/layout operations during teardown.
    // Without this, clearing groupDescriptions/sortDescriptions in onGridWillUnmount
    // triggers a CollectionView change → grid refresh → _adjustWidths → null DOM crash.
    if (this.grid) {
      this.grid.beginUpdate();
    }

    if (this.props.showGroupPanel && this.panel && this.panel.hostElement) {
      this.panel.removeEventListener(this.panel.hostElement)
    }

    if (this.props.addGrandTotalRow && this.grid && this.grid.collectionView) {
      this.grid.loadedRows.removeHandler(this.loadedRowsHandler)
      this.grid.collectionView.collectionChanged.removeHandler(
        this.grandTotalRowHandler,
      )
      this.grid.cellEditEnded.removeHandler(this.grandTotalRowHandler)
    }

    if (this.props.showFrozenBars) {
      if (this.freezeBarCol) {
        // $FlowFixMe
        this.freezeBarCol.componentWillUnmount()
      }
    }

    if (typeof this.props.onGridWillUnmount === 'function') {
      this.props.onGridWillUnmount()
    }
    this.props.isMobile && document.removeEventListener('touchstart', this.menuHandler);

    // Dispose the Wijmo grid control to release all internal references and
    // prevent any deferred operations from accessing removed DOM elements.
    if (this.grid) {
      this.grid.dispose();
    }
  }

  cleanAndnitFormatters = (formatters: any, args?: FormatterArgs) => {
    if (typeof this.formatters === 'function' || typeof this.formatters === 'object') {
      this.formatters.forEach((f) => {
        this.grid.formatItem.removeHandler(f)
      })
    }

    if (typeof formatters === 'function') {
      this.formatters = formatters(args)

      this.formatters.forEach((f) => {
        this.grid.formatItem.addHandler(f)
      })
    }
  }

  componentDidUpdate(prevProps: Props) {
    // TODO: this check is not enough
    if (
      this.props.formattersArgs &&
      !deepEqual(prevProps.formattersArgs, this.props.formattersArgs)
    ) {
      this.cleanAndnitFormatters(
        this.props.formatters,
        this.props.formattersArgs,
      )
    }

    if (this.props.showFrozenBars) {
      if (this.freezeBarCol) {
        // $FlowFixMe
        this.freezeBarCol.repositionFreezeBar()
      }
    }

    if (
      !prevProps.active &&
      this.props.active &&
      this.grid &&
      typeof this.grid.refresh === 'function'
    ) {
      if (this.props.addGrandTotalRow) {
        this.grandTotalRowHandler()
      }

      // This is to fix the issue where sometimes the Grid only shows
      // the top-left part of the whole grid
      this.grid.refresh()
    }
    if (this.props.isMobile && !this.state.disabledInertialScrolling && this.gridRef && this.gridRef.current) {
      this.disableInertialScrolling(this.gridRef.current.control);
      this.setState({ disabledInertialScrolling: true });
    }
    if (this.props.isMobile && this.props.handlerAdded && !this.state.handlerAdded) {
      document.addEventListener('touchstart', this.menuHandler);
      this.setState({ handlerAdded: true });
    } else if (this.props.isMobile && !this.props.handlerAdded && this.state.handlerAdded) {
      document.removeEventListener('touchstart', this.menuHandler);
      this.setState({ handlerAdded: false });
    }
  }

  updateAggregateRow = (grid: FlexGrid, aggregateRow: GroupRow) => {
    if (
      this.grandTotalRowAdded &&
      this.props.collection &&
      Array.isArray(this.props.collection.items)
    ) {
      grid.columns.forEach((col) => {
        let total
        /**
         * grandTotalRowCustomContent let us put arbitrary content within the 'Total' column
         * under the grand total row. See the 'order' module for an example.
         */
        if (
          col.binding === 'Total' &&
          typeof this.props.grandTotalRowCustomContent === 'function'
        ) {
          total = this.props.collection.items.reduce((reducer, item) => {
            if (item && Object.keys(item).length > 0) {
              // $FlowFixMe
              reducer += this.props.grandTotalRowCustomContent(item)
            }

            return reducer
          }, 0)
        } else if (col.binding && col.aggregate) {
          total = wjcCore.getAggregate(
            col.aggregate,
            this.props.collection.items,
            col.binding,
          )
        }

        grid.setCellData(aggregateRow.index, col.index, total, false)
        total && this.props.setAggregateTotal && this.props.setAggregateTotal(total)
        // TODO: In case we need to add aggregateTotal from GridApi to the saved Orders
        // const { aggregateTotal, itemId, setAggregateTotal } = this.props;
        // if (setAggregateTotal) {
        //   if (aggregateTotal && itemId) {
        //     const currentTotal = aggregateTotal[itemId];
        //     !currentTotal && total && setAggregateTotal(total, itemId);
        //   } else {
        //     total && setAggregateTotal(total)
        //   }
        // }



        if (aggregateRow.index !== this.props.collection.items.length) {
          grid.rows.moveElement(aggregateRow.index, -1)
        }
      })
    }
  }

  onLoadedRows = (grid: FlexGrid, aggregateRow: GroupRow) => {
    grid.rows.push(aggregateRow)
  }

  addGrandTotalRow = (grid: FlexGrid) => {
    const aggregateRow = new GroupRow()
    aggregateRow.cssClass = 'wj-aggregate-row'

    this.loadedRowsHandler = () => this.onLoadedRows(grid, aggregateRow)

    grid.rows.push(aggregateRow)
    grid.loadedRows.addHandler(this.loadedRowsHandler)

    this.grandTotalRowAdded = true

    this.updateAggregateRow(grid, aggregateRow)
    this.grandTotalRowHandler = () =>
      this.updateAggregateRow(grid, aggregateRow)

    grid.collectionView.collectionChanged.addHandler(this.grandTotalRowHandler)
    grid.cellEditEnded.addHandler(this.grandTotalRowHandler)
  }

  onGridInitialized = (g: FlexGrid) => {
    this.grid = g

    if (this.props.showGroupPanel && this.panelGroupInitialized !== true) {
      this.connectGroupPanelWithGrid(g)
    }

    if (this.props.addGrandTotalRow && this.grandTotalRowAdded !== true) {
      this.addGrandTotalRow(g)
    }

    if (typeof this.props.formatters === 'function') {
      this.cleanAndnitFormatters(
        this.props.formatters,
        this.props.formattersArgs,
      )
    }

    // by default it selects the first row
    this.removeSelection()

    // this includes the inline filter for each column
    new FlexGridFilter(g)

    if (this.props.showFrozenBars) {
      this.freezeBarCol = new FreezeBar({
        onColFreezed: this.props.onColFreezed,
        frozenColumns: this.props.frozenColumns,
      })
      this.freezeBarCol.addFreezeBar(g)
    }

    // reset scroll's position (to start at the top)
    this.grid.scrollPosition = 0

    // changing the max number for the filter values after both FlexGrid and FlexGridFilter are initialized
    this.gridFilter && this.changeMaxFilterValue(g);
  };

  changeMaxFilterValue = (grid) => {
    for (var c = 0; c < grid.columns.length; c++) {
      this.gridFilter.getColumnFilter(c).valueFilter.maxValues = FILTER_VALUES_LIMIT;
    }
  };

  onGridChanged = (handler?: () => mixed) => {
    if (handler) {
      handler()
    }
  }

  forceColumnDateType = (columnsMapping?: ColumnsMap) => {
    const headersWithDates = ['PO ETA', 'PO Date', 'Rcpt Date']
    const headerWithNumbers = [
      'Available',
      'Price (c)',
      'Price (b)',
      'Discount (c)',
      'Discount (b)',
      'On Hand',
      'On SO',
      'On MO',
      'On BO',
      'On PO',
    ]

    if (columnsMapping) {
      return columnsMapping.map((col) => {
        if (headersWithDates.includes(col.header)) {
          return {
            ...col,
            dataType: 'Date',
          }
        }

        if (headerWithNumbers.includes(col.header)) {
          return {
            ...col,
            dataType: 'Number',
          }
        }

        return { ...col }
      })
    }

    return null
  }

  // initializing gridFilter so it can be manipulated in this component and passing to parent
  setGridFilter = (filter) => {
    this.gridFilter = filter;
    this.props.setFlexGridFilter(filter);
  };

  // if not tapping on grid or menu, it will clear the row selection and close the menu
  menuHandler = (e) => {
    if (this.props.isMobile
      && this.props.menuRef
      && this.props.menuRef.current
      && this.state.currentItem
      && !this.props.menuRef.current.contains(e.target) //checks if the menu is not being tapped on
      && !this.gridRef.current._hostRefValue.contains(e.target) //checks that the grid is not being tapped on
    ) {
      const modal = document.getElementsByClassName('modal')[0]
      const modalOpen = modal && modal.classList.contains('in')
      if (!modalOpen) {
        this.removeSelection();
        this.props.onClearSelection();
        this.props.onCurrentItemChanged(null);
      }
    }
  };

  disableInertialScrolling = (grid) => {
    let root = grid._root,
      sp = null,
      start = null;
    root.addEventListener('touchstart', e => {
      sp = grid.scrollPosition;
      start = e;
    });
    root.addEventListener('touchmove', e => {
      grid.scrollPosition = new wijmo.Point(
        sp.x + (e.pageX - start.pageX),
        sp.y + (e.pageY - start.pageY),
      );
      e.preventDefault();
      e.stopPropagation();
    });
  }

  render() {
    const columns = this.forceColumnDateType(this.props.columnsMapping)
    const multiColumnSort = this.props.multiColumnSort;

    return (
      <React.Fragment>
        <DragDropOverlay>
          {({ draggable, isMobile }) => {
            return (
              <>
                {this.props.collection &&
                  (this.props.isFullPage || this.props.hasDataToDisplay) && (
                    <React.Fragment>
                      <Container
                        hasAllColumnsHidden={this.props.hasAllColumnsHidden}
                        isFullPage={this.props.isFullPage}
                        direction="column"
                        gridHeight={this.props.gridHeight}
                      >
                        {this.props.showGroupPanel && (
                          <div
                            css={{
                              width: '100%',
                            }}
                          >
                            <GroupPanel
                              id={`panel-${this.id}`}
                              hideGroupedColumns={false}
                              placeholder="Drag columns here to create Groups"
                            />
                          </div>
                        )}
                        <FlexGrid
                          allowSorting={multiColumnSort ? "MultiColumn" : "SingleColumn"}
                          ref={this.gridRef}
                          id={`grid-${this.id}`}
                          itemsSource={this.props.collection}
                          columns={columns}
                          allowDragging={isMobile ? draggable : true}
                          onSelectionChanged={(e) => {
                            // e.col === 0 only when there is no user interaction involved.
                            // so this is a guard to avoid unnecessary updates
                            if (e.col !== 0) {
                              this.props.onRowSelected(this.grid);
                            }
                          }}
                          initialized={this.onGridInitialized}
                          onSortedColumn={() =>
                            this.onGridChanged(this.props.onColSorted)
                          }
                          onResizedColumn={() =>
                            this.onGridChanged(this.props.onColResized)
                          }
                          onDraggedColumn={() =>
                            this.onGridChanged(this.props.onColDragged)
                          }
                          onCellEditEnded={(args) => {
                            if (
                              this.props.onCellEditEnded &&
                              typeof this.props.onCellEditEnded === 'function'
                            ) {
                              // $FlowFixMe
                              this.props.onCellEditEnded({
                                row: args.row,
                                col: args.col,
                                newValue: this.grid.getCellData(
                                  args.row,
                                  args.col,
                                ),
                                oldValue: args.data,
                              });
                            }
                          }}
                        >
                          <FlexGridFilter
                            onFilterApplied={(a) => {
                              // needed to update other parts of the page, like paginators, etc.
                              this.props.onGridUpdated();
                            }}
                            initialized={this.setGridFilter}
                          />
                        </FlexGrid>
                        {(this.props.loading ||
                          this.props.refetching ||
                          this.props.playResetAnimation) && <Loading />}
                      </Container>
                    </React.Fragment>
                  )}
              </>
            );
          }}
        </DragDropOverlay>
      </React.Fragment>
    )
  }
}

export default App
